import { DetailsHistory } from 'src/app/historial/models/manager-content-vehicle-history-drawer.model';

export function formatMessageToastHistory(details: DetailsHistory | undefined) {
  if (!details) return '';
  const start = formatTimelineDate(details.start_date);
  const end = formatTimelineDate(details.end_date);
  return `${start} - ${end}`;
}

export function formatTimelineDate(value: string): string {
  if (!value) return '';
  let cleaned = value.replace(/(Z|[+-]\d{2}:\d{2})$/, '');
  const [datePartRaw, timePartRaw = ''] = cleaned.split('T');
  const datePart = (datePartRaw || '').replace(/-/g, '/');
  let timePart = timePartRaw.split('.')[0] || '';
  if (/^\d{2}:\d{2}$/.test(timePart)) {
    timePart = `${timePart}:00`;
  } else if (!/^\d{2}:\d{2}:\d{2}$/.test(timePart)) {
    timePart = '00:00:00';
  }
  return `${datePart} ${timePart}`.trim();
}

export function formatDateOnly(value: string): string {
  if (!value) return '';
  const cleaned = value.replace(/(Z|[+-]\d{2}:\d{2})$/, '');
  const [datePartRaw] = cleaned.split('T');
  const datePart = datePartRaw || '';
  const [y, m, d] = datePart.split('-');
  if (y && m && d) {
    return `${d.padStart(2, '0')}/${m.padStart(2, '0')}/${y}`;
  }
  return datePart.replace(/-/g, '/');
}

export function formatTimeOnly(value: string): string {
  if (!value) return '00:00:00';
  const cleaned = value.replace(/(Z|[+-]\d{2}:\d{2})$/, '');
  const [, timePartRaw = ''] = cleaned.split('T');
  let timePart = timePartRaw.split('.')[0] || '';
  if (/^\d{2}:\d{2}$/.test(timePart)) {
    timePart = `${timePart}:00`;
  } else if (!/^\d{2}:\d{2}:\d{2}$/.test(timePart)) {
    timePart = '00:00:00';
  }
  return timePart;
}

/**
 * Formatea fechas en formato "2025/08/14 01:45:33" para DateTracker
 * Extrae solo la parte de la fecha (DD/MM/YYYY)
 */
export function formatDateTrackerDate(value: string): string {
  if (!value) return '';

  // Formato esperado: "2025/08/14 01:45:33"
  const match = value.match(/^(\d{4})\/(\d{1,2})\/(\d{1,2})/);
  if (match) {
    const [, year, month, day] = match;
    return `${day.padStart(2, '0')}/${month.padStart(2, '0')}/${year}`;
  }

  // Fallback: si no coincide el formato, devolver el valor original
  return value;
}

/**
 * Formatea fechas en formato "2025/08/14 01:45:33" para DateTracker
 * Extrae solo la parte de la hora (HH:MM:SS)
 */
export function formatDateTrackerTime(value: string): string {
  if (!value) return '00:00:00';

  // Formato esperado: "2025/08/14 01:45:33"
  const match = value.match(/(\d{1,2}):(\d{1,2}):(\d{1,2})$/);
  if (match) {
    const [, hour, minute, second] = match;
    return `${hour.padStart(2, '0')}:${minute.padStart(
      2,
      '0'
    )}:${second.padStart(2, '0')}`;
  }

  // Fallback: si no coincide el formato, devolver el valor original
  return value;
}

/**
 * Redondea un número a 2 decimales máximo
 * Útil para valores como 315.5468059999995 → 315.55
 */
export function roundToTwoDecimals(
  value: number | string | null | undefined
): string {
  if (value === null || value === undefined) return '0.00';

  const numValue = typeof value === 'string' ? parseFloat(value) : value;

  if (isNaN(numValue)) return '0.00';

  // Redondear a 2 decimales
  const rounded = Math.round(numValue * 100) / 100;

  // Formatear para mostrar siempre 2 decimales si es necesario
  return rounded.toFixed(2);
}

/**
 * Redondea un número a 2 decimales máximo y retorna solo el número
 * Sin formateo de string, útil para cálculos
 */
export function roundToTwoDecimalsNumber(
  value: number | string | null | undefined
): number {
  if (value === null || value === undefined) return 0;

  const numValue = typeof value === 'string' ? parseFloat(value) : value;

  if (isNaN(numValue)) return 0;

  // Redondear a 2 decimales
  return Math.round(numValue * 100) / 100;
}
